import * as React from 'react';
import * as shortid from 'shortid';
import { actions } from 'react-redux-form';
import { assign } from 'lodash';
import { Card, Form, IconButton } from '../';

interface Props {
  booking: any;
  title: string;
  charges: Array<any>;
  handleChange: Function;
}

interface State {
  charges: Array<any>;
}

class BookingChargeList extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { charges: [...props.charges] };
  }

  render() {
    return (
      <div className="field">
        <label>{this.props.title}</label>
        {this.state.charges.map((charge, index) => (
          <Card list key={charge.id}>
            <Form
              fields={[
                {
                  name: 'amount',
                  label: 'Amount (£)',
                  type: 'number',
                },
                { name: 'description', label: 'Description', type: 'text' },
                { name: 'id', type: 'hidden' },
              ]}
              hasButton={false}
              type="charge"
              handleChange={(data) => {
                const updatedData = assign({}, data);
                if (updatedData.amount === '') {
                  updatedData.amount = 0;
                }
                const charges = this.state.charges;
                charges[index] = updatedData;
                this.props.handleChange(charges);
                this.setState({ charges });
              }}
              getDispatch={(dispatch) => {
                dispatch(actions.change('charge.id', charge.id));
                dispatch(actions.change('charge.amount', charge.amount));
                dispatch(
                  actions.change('charge.description', charge.description),
                );
              }}
            />
            <IconButton
              icon="trash"
              className="is-danger is-outlined field"
              handleClick={() => {
                const charges = this.state.charges;
                charges.splice(index, 1);
                this.props.handleChange(charges);
                this.setState({ charges });
              }}
            >
              Remove
            </IconButton>
          </Card>
        ))}
        <IconButton
          icon="plus"
          className="is-default is-fullwidth"
          handleClick={() => {
            const charges = this.state.charges;
            charges.push({
              id: shortid.generate(),
              amount: 0,
              description: '',
            });
            this.props.handleChange(charges);
            this.setState({ charges });
          }}
        >
          Add New
        </IconButton>
      </div>
    );
  }
}

export default BookingChargeList;
